export default "__VITE_ASSET__Dsdh_YC6__"